import type { SessionService } from './session-service';

/**
 * Closes that are part of normal operation: the client is lazy, so the socket
 * goes away whenever the last subscription ends — on a route change, on
 * teardown, on a deliberate sign-out.
 */
const NORMAL_CLOSE_CODES = [1000, 1001];

/**
 * Makes a dead socket a session signal (PSTUDIO-4022).
 *
 * The session subscription only reports an auth-shaped error when the socket
 * RECONNECTS as `anonymous`; a transport death arrives as a network error with
 * no GraphQL content, so nothing in it names the session and the cross-tab
 * logout signal simply goes quiet. Asking Kratos costs one request and cannot
 * sign anyone out on its own — an alive session answers 200, and an
 * inconclusive answer is `unknown`, which does nothing.
 */
export function createSocketSessionHooks(session: SessionService) {
  return {
    closed: (event: unknown) => {
      const code = (event as { code?: number } | undefined)?.code;

      if (code !== undefined && NORMAL_CLOSE_CODES.includes(code)) return;

      void session.revalidate();
    },
  };
}
